export const superAccessRoles = ["PDG", "ADMINISTRATEUR"];
export const fullAccessRoles = [...superAccessRoles, "DIRECTEUR_GENERAL"];
export const agencyManagerRoles = ["MANAGER_AGENCE", "MANAGER_ADMIN_FINANCE_OPS"];
export const fieldRoles = ["AGENT_COMMERCIAL", "AGENT_RECOUVREMENT", "AGENT_CREDIT"];

const role = (user) => String(user?.role_code || "").toUpperCase();

export function hasFullAccess(user) {
  return fullAccessRoles.includes(role(user));
}

export function hasSuperAccess(user) {
  return superAccessRoles.includes(role(user));
}

export function hasAgencyManagerAccess(user) {
  return agencyManagerRoles.includes(role(user));
}

export function hasManagementAccess(user) {
  return hasFullAccess(user) || hasAgencyManagerAccess(user);
}

export function isFieldUser(user) {
  return fieldRoles.includes(role(user));
}

export function canOperateRecovery(user) {
  return role(user) === "AGENT_RECOUVREMENT";
}

export function canUseTreasury(user) {
  return hasManagementAccess(user);
}

export function canUseReports(user) {
  return hasManagementAccess(user);
}

export function canUseFunds(user) {
  return hasSuperAccess(user) || role(user) === "INVESTISSEUR";
}

export function canManageProducts(user) {
  return hasSuperAccess(user);
}

export function canManageUsers(user) {
  return hasManagementAccess(user);
}

export function canAudit(user) {
  return hasSuperAccess(user) || role(user) === "CONTROLE_INTERNE";
}

export function isDirectorGeneral(user) {
  return role(user) === "DIRECTEUR_GENERAL";
}

export function displayModeKey(user) {
  return user?.id || user?.userId ? `owsur-display-mode-${user.id || user.userId}` : "owsur-display-mode";
}
